import React from "react";
import { motion } from "framer-motion";
import { LogIn, Youtube } from "lucide-react";
import logoimg from "../../images/hero1.png";
import "./Header.css"; // Ensure this does not add height/overflow styles

export default function HeroSection() {
  return (
    <section className="w-full px-6 sm:px-12 pt-24 pb-10">
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center justify-between gap-10 md:gap-20">
        {/* Text Content */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center md:text-left space-y-6 w-full md:max-w-xl"
        >
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">
            <span className="block text-black font-normal">Welcome to</span>
            <span className="title-algo font-semibold">algo</span>
            <span className="title-turtle font-semibold">Turtle</span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-700 font-light">
            India's first AI-powered algorithmic trading platform designed to
            revolutionize your trading experience.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a
              href="/login"
              className="inline-flex items-center gap-2 px-6 py-3 bg-green-700 text-white rounded-md font-medium hover:bg-[#2d3191] transition-transform transform hover:scale-105"
            >
              <LogIn size={18} />
              Login
            </a>
            <a
              href="https://www.youtube.com/@algoTurtle"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-red-500 text-white rounded-md font-medium hover:bg-red-600 transition-transform transform hover:scale-105"
            >
              <Youtube size={18} />
              Watch Demo
            </a>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="w-full flex justify-center md:justify-end"
        >
          <img
            src={logoimg}
            alt="AI Trading Illustration"
            className="rounded-lg w-full max-w-xs sm:max-w-sm md:max-w-md"
          />
        </motion.div>
      </div>
    </section>
  );
}
